import React from 'react';
import '../../../pages/LandingPage/HeroBannerSection/HeroBannerSection.scss';
import './SpecialEventBannerSection.scss';
import Button from '../../Button/Button';
import truckMonthTextIcon from '../../../assets/icons/ford-truck-month-text.svg';
import {SPECIAL_EVENT_PAGE_NAME} from '../../../utils/constants/constants';

function SpecialEventBannerSection({getPrequalified, event}) {
  if (event === SPECIAL_EVENT_PAGE_NAME) {
    return (
      <div className='banner--truckmonth-container'>
        <div className='banner--truckmonth-text-container'>
          <div className='banner--truckmonth-text-1'>Zero credit impact.</div>
          <div className='banner--truckmonth-text-1'>zero obligations.</div>
          <div className='banner--truckmonth-text-2'>
            Quickly and easily prequalify with <br />
            Ford Credit for your next truck.
          </div>
          <div className='banner--truckmonth-button-container'>
            <Button dataTestId='get-prequalified-button' label='Get Prequalified' onClick={getPrequalified} />
          </div>
        </div>
        <div className='banner--ford-truckmonth-icon-container'>
          <img className='banner--ford-truckmonth-icon' src={truckMonthTextIcon} alt='ford truck month text in between two brackets' />
        </div>
      </div>
    );
  }

  if (event === 'yese') {
    return (
      <div className='banner--yese-container'>
        <span className='banner--yese-text-1'>MAKE THE</span>
        <div className='banner--yese-holiday-container'>
          <div className='banner--yese-holiday-section'>
            <span className='banner--yese-holiday-text-1'>HOLIDAYS</span>
            <span className='banner--yese-holiday-text-2'>BRIGHT</span>
          </div>
          <span className='banner--yese-holiday-text-3'>SALES EVENT</span>
        </div>
        <div className='banner--yese-prequalified-text-container'>
          <span className='banner--yese-prequalified-text-1'>Our best sales of the year are here.</span>
          <span className='banner--yese-prequalified-text-1'>Get prequalified today.</span>
        </div>
        <span className='banner--yese-credit-impact-text'>Zero credit impact, no obligation.</span>
        <div className='banner--yese-button-container'>
          <Button dataTestId='get-prequalified-button-yese' label='Get Prequalified' onClick={getPrequalified} buttonStyle='primary' />
        </div>
      </div>
    );
  }
}

export default SpecialEventBannerSection;
